import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, TemplateRenderRequest, TemplateRenderResponse } from '../types/showcase';

/** C011 템플릿 엔진 데모(순수) — POST .../template/render (queue #646 §R646-2). */
export function useTemplateRender() {
  return useMutation<TemplateRenderResponse, ApiError, TemplateRenderRequest>({
    mutationFn: (req) => showcaseApi.templateRender(req),
    mutationKey: ['common-showcase', 'template', 'render'],
  });
}
